import {
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";

import { ActivatedRoute } from "@angular/router";
import { ItemDetail } from "app/model/entities/item-detail";
import { DomainBaseComponent } from "app/shared/domain-base.component";
import { DomainService } from "app/shared/domain.service";
import { PrintFns } from "app/shared/print-fns";
import { UtilFns } from "app/shared/util-fns";
import { environment } from "environments/environment";
import _ from "lodash";
import moment from "moment-mini";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-printable-jo-wip",
  templateUrl: "./printable-jo-wip.component.html",

  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PrintableJoWipComponent
  extends DomainBaseComponent
  implements OnDestroy
{
  @ViewChild("printableArea") printElementRef: ElementRef;

  joHeaderId: number;
  flatDetails: any[];

  timestamp: string;

  constructor(
    protected domainService: DomainService,
    protected route: ActivatedRoute,

    private elementRef: ElementRef
  ) {
    super(domainService);

    this.route.paramMap
      .pipe(takeUntil(this.onDestroy))
      .subscribe((paramMap) => {
        this.updateFromContext();
      });
  }

  ngOnDestroy(): void {}

  async updateFromContext() {
    await this.dbQueryService.cacheAll();

    this.joHeaderId = +this.route.snapshot.params["joHeaderId"];

    let joDetails = await this.dbQueryService.getJoDetailsForJoHeader(
      this.joHeaderId
    );
    let itemDetails = _.flatMap(joDetails.map((jod) => jod.itemDetails));
    itemDetails = itemDetails.filter(
      (itd) => itd.isInProcess && itd.invoiceHeaderId == null
    );
    this.flatDetails = this.flattenJoDetails(itemDetails);
    this.timestamp = moment(new Date(Date.now())).format("MM/DD/YY HH:MM:SS");

    this.isPageReady = true;

    setTimeout(() => {
      // if printing or headless browser, use print view
      const mediaQueryList = window.matchMedia("print");
      if (
        mediaQueryList.matches ||
        window.navigator.userAgent.includes("Headless")
      ) {
        this.preparePrint();
      }
    }, 0);
  }

  flattenJoDetails(itds: ItemDetail[]) {
    const fmtCurrency = UtilFns.fmtCurrency;

    const flatDetails = itds.map((itd) => {
      const jod = itd.joDetail;
      const jodAddons = jod.joDetailAddons;
      const pt = jod.product.productType;

      const mods = itd.itemDetailAddons.map((itdAddon) => {
        const jodemb = jodAddons.find(
          (jm) =>
            jm.addonId == itdAddon.addonId &&
            jm.additionalInfo == itdAddon.additionalInfo
        );
        return {
          status: "Not yet implemented",
          description: itdAddon.addon.nameAndLocation,
          info: itdAddon.additionalInfo,
          unitPrice:
            jodemb && jodemb.unitPriceAmt > 0
              ? fmtCurrency(jodemb.unitPriceAmt)
              : "",
        };
      });

      return {
        id: itd.id,
        mfr: pt.manufacturer.name,
        desc: pt.description,
        style: pt.style,
        featureChoicesExtract: jod.product.getFeatureChoicesExtract(),
        unitPrice: fmtCurrency(jod.unitPriceAmt),
        unitOs: fmtCurrency(jod.unitOversizeAmt),
        unitCus: fmtCurrency(jod.unitCustomAmt),
        mods: mods,
      };
    });
    return flatDetails;
  }

  async print() {
    const pdfurl =
      environment.apiRoot +
      "api/pdf/pdffromurl/JO-WIP" +
      this.joHeaderId +
      "?url=" +
      UtilFns.getBaseUrl() +
      "printable-jo-wip/" +
      this.joHeaderId;

    const pwin = window.open(pdfurl, "_blank");
  }

  preparePrint() {
    let el: HTMLElement =
      this.printElementRef && this.printElementRef.nativeElement;
    if (el == null) {
      el = this.elementRef && this.elementRef.nativeElement;
    }
    if (!el) {
      return;
    }
    PrintFns.printElement(el);
  }
}
